import { Typography } from "antd";

const { Text } = Typography

export const FormLabel = ({ children }: { children: React.ReactNode; }) => {
  return <Text type="secondary" style={{ marginBottom: 4, display: 'inline-block' }}>
    {children}
  </Text>;
};
